import { globalPrompt } from '@/components/message'
import useGlobalModel from '@/model/globalModel'
import { convertRes2Blob } from '@/utils/exportFile'
import { useLockFn } from 'ahooks'
import { message } from 'antd'
import { createModel } from 'hox'
import { useState } from 'react'
import { inquiryService } from '../../inquiryService'
import { IInquiryFormFields, IInquiryInsert, IInquiryInvoiceInfo, IInquiryUpdate, IInquiryGoods } from '../../inquiryTypes'

export const useInquiryDetailsMode = createModel(function () {
    const { user, setLoadingInfo } = useGlobalModel()
    const initFormVal = {
        createUser: user.userName,
    } as any
    //编辑缓存
    const [editFormVal, setEditFormVal] = useState<IInquiryFormFields>(initFormVal)
    const [editGoodsList, setEditGoodsList] = useState<IInquiryGoods[]>([])

    //新增缓存
    const [addFormVal, setAddFormVal] = useState<IInquiryFormFields>(initFormVal)
    const [addGoodsList, setAddGoodsList] = useState<IInquiryGoods[]>([])

    const [saveLoading, setSaveLoading] = useState<boolean>(false) //保存loading

    //新增
    const [addGoodsModal, setAddGoodsModal] = useState<boolean>(false)

    //表单新增修改
    const updateAddFormVal = (val: object | null) => {
        val ? setAddFormVal({ ...addFormVal, ...val }) : setAddFormVal(initFormVal)
    }
    //表单新增修改
    const updateEditFormVal = (val: object | null) => {
        val ? setEditFormVal({ ...editFormVal, ...val }) : setEditFormVal(initFormVal)
    }

    //重置缓存
    const resetEditCatch = () => {
        updateEditFormVal(null) //表单
        setEditGoodsList([])
    }
    const resetAddCatch = () => {
        updateAddFormVal(null)
        setAddGoodsList([])
    }

    //获取一条数据
    const getInquiryDetailOne = async (id: string) => {
        let { retData } = await inquiryService.one(id)
        if (retData) {
            let { sumInquiryDetailsList, ...formVal } = retData
            setEditFormVal(formVal)
            setEditGoodsList(sumInquiryDetailsList || [])
        }
    }

    //新增 Api(包含补单)
    const insertInquiry = useLockFn(async (val: IInquiryFormFields) => {
        let data: IInquiryInsert = {
            ...val,
            sumInquiryDetailsList: addGoodsList
        }
        let { retData } = await inquiryService.insert(data)
        if (retData) {
            globalPrompt('message', { text: '新增成功', type: 'success' })
        } else {
            globalPrompt('message', { text: '失败', type: 'error' })
        }
        return retData
    })

    //编辑 Api
    const updateInquiry = async (val: IInquiryFormFields & { id: string }) => {
        try {
            setSaveLoading(true)
            let data: IInquiryUpdate = {
                ...val,
                sumInquiryDetailsList: editGoodsList
            }
            let { retData } = await inquiryService.update(data)
            if(retData){
                globalPrompt('message', { text: '编辑成功', type: 'success' })
                getInquiryDetailOne(val.id).then((res) => message.success('已刷新！'))
            }else{
                globalPrompt('message', { text: '编辑失败', type: 'success' })
                getInquiryDetailOne(val.id).then((res) => message.success('已刷新！'))
            }
            setSaveLoading(false)
        } catch (error) {
            setSaveLoading(false)
            getInquiryDetailOne(val.id).then((res) => message.success('页面已刷新！'))
        }
    }



    //导出模版
    const downloadGoodsTemplate = async () => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            let result = await inquiryService.exportTemplate();
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    };

    return {
        editFormVal,
        addFormVal,
        updateAddFormVal,
        updateEditFormVal,
        insertInquiry,
        updateInquiry,
        getInquiryDetailOne,
        resetEditCatch,
        resetAddCatch,
        saveLoading,
        setSaveLoading,
        editGoodsList,
        setEditGoodsList,
        addGoodsList,
        setAddGoodsList,
        addGoodsModal,
        setAddGoodsModal,
        downloadGoodsTemplate
    }
})
